export const getAlertMessage = state => state.ui.alertMessage;
export const isErrorMessage = state => state.ui.error;
